module.exports = require('./colorbrewer.js');



//////////////////
// WEBPACK FOOTER
// ./~/colorbrewer/index.js
// module id = 973
// module chunks = 6